export const chartIssueTransactionVolume = {
    chartLayout: {
        margin: { t: 7, r: 7, b: 20, l: 42 },
        font: { size: 12 },
        bargap: 0.15,
        bargroupgap: 0.1,
    },
    tickColor: '#e4e4e4',
    tickFont: {
        family: 'Roboto, Arial, Helvetica, sans-serif',
        size: 12,
        color: '#7f7f7f',
    },
    barColors: ['#74b58f', '#5c4f84'],
    zeroLineColor: '#e4e4e4',
    hoverlabel: {
        bgcolor: '#4a4a4a',
        bordercolor: '#4a4a4a',
        font: {
            color: '#ffffff',
            family: 'Roboto, Arial, Helvetica, sans-serif',
            size: 12
        },
        align: 'left'
    }
};
